import Annotation from '@/fhirworks/types/Annotation';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';
import Identifier from '@/fhirworks/types/Identifier';
import Period from '@/fhirworks/types/Period';
import Reference from '@/fhirworks/types/Reference';
import merge from 'lodash/merge';
import DomainResource from './DomainResource';

/**
 * FHIR R4 Flag resource — used for patient risk flags.
 *
 * `code` holds the fixed patient-risk-flag marker, `category` holds the risk category,
 * and the risk level lives in the `riskLevel` first-class extension
 * (see client/src/common/riskFlagConstants.js). `status` is 'active' while the flag
 * stands and 'inactive' once it is closed / stepped down / resolved; `period.start`
 * marks activation and `period.end` marks closure.
 *
 * First-class extensions:
 * - `note` [Annotation]: the note log (justification on each change + management notes).
 * - `threadId` String: shared by every Flag in one risk thread so history can be stitched.
 * - `riskLevel` String: the risk level tier slug (high | moderate | low | historical).
 */
export default class Flag extends DomainResource {
    static __className = 'Flag';
    __objectStructure = {
        identifier: [Identifier],
        status: String,
        category: [CodeableConcept],
        code: CodeableConcept,
        subject: Reference,
        period: Period,
        encounter: Reference,
        author: Reference,

        // first class extension
        note: [Annotation],
        threadId: String,
        riskLevel: String,
    };

    constructor(constructJson, className = 'Flag') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
